import { takeLatest, call, put } from 'redux-saga/effects';
import * as anniversaryActions from 'redux/ducks/Anniversary/AnniversaryDucks';
import * as alertActions from 'redux/ducks/common/alertDucks';
import pimsApi from 'api/pims/pimsApi';

export function* createAnniversaryComp({ payload }) {
  try {
    const response = yield call(pimsApi.createCalender, payload);
    yield put(anniversaryActions.createAnniversaryCompSuccess(response));
  } catch (error) {
    if (error.errorCode !== 'SC199') {
      yield put(
        alertActions.open({
          message: [error.errorCode],
        }),
      );
    } else {
      // 이미 생성이 되어있는 경우는 HOL+COMPCD 로 사용
      yield put(anniversaryActions.updateAnniversaryCode(payload.publicTargets[0].targetId));
    }
  }
}

export function* createHoliday({ payload }) {
  try {
    const response = yield call(pimsApi.createHoliday, payload);
    yield put(anniversaryActions.createHolidaySuccess(response));
    yield put(anniversaryActions.updateAnniversaryList(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorMessage] }));
  }
}

export function* deleteHoliday({ payload }) {
  try {
    const response = yield call(pimsApi.deleteHoliday, payload);
    yield put(anniversaryActions.deleteHolidaySuccess(response));
    yield put(anniversaryActions.removeAnniversaryList(payload));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorMessage] }));
  }
}

export default function* AdminInfoSaga() {
  yield takeLatest(anniversaryActions.createAnniversaryComp, createAnniversaryComp);
  yield takeLatest(anniversaryActions.createHoliday, createHoliday);
  yield takeLatest(anniversaryActions.deleteHoliday, deleteHoliday);
}
